import React, { Component } from 'react';

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

class Banner extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'


    return  ( 
			
			<Carousel showThumbs={false} autoPlay={true} infiniteLoop={true}>
				
				{/* <div>
				<br />
				<br />
				<br />
					<img className='d-none d-lg-block' src={publicUrl+"assets/img/website/MIET_Social-Media-Banners-01.jpg"} />
				</div>
				<div>
				<br />
				<br />
				<br />
					<img className='d-none d-lg-block' src={publicUrl+"assets/img/website/MIET_Social-Media-Banners_JEE.jpg"} />
				</div>
				<div>
				<br />
				<br />
				<br />
					<img className='d-none d-lg-block' src={publicUrl+"assets/img/website/MIET_Social-Web-Banner.jpg"} />
				</div> */}
				<div>
				     <br/><br/>
					<img className='d-none d-lg-block' src={publicUrl+"assets/img/website/MIET-NEET-Year-Admission-Web-Banner.jpg"} />
                    <img className='d-lg-none' src={publicUrl+"assets/img/website/MIET-NEET-Year-Admission-Mob-Banner.jpg"} />  
				</div>
				<div>
				     <br/><br/>
					{/* <img className='d-none d-lg-block' src={publicUrl+"assets/img/website/MIET_Social-Web-r.jpg"} />
			<img className='d-lg-none' src={publicUrl+"assets/img/website/MIET_JEE-Post-Mobile-r.jpg"} />   */}

					<img className='d-none d-lg-block' src={publicUrl+"assets/img/website/Admission-Post-Banner.jpg"} />
					<img className='d-lg-none' src={publicUrl+"assets/img/website/Admission-post-Mobile-Banner.jpeg"} />  
				</div>
				{/* <div>
				<br/><br/>
					<img className='d-none d-lg-block' src={publicUrl+"assets/img/website/MIET_NEET-Post-v1-Web-Banner.jpg"} />
			<img className='d-lg-none' src={publicUrl+"assets/img/website/MIET_NEET-Mobile-Banner.jpg"} /> 
				</div> */}
				{/* <div>
				<br/><br/>
					<img className='d-none d-lg-block' src={publicUrl+"assets/img/website/NATA-Post-v1-Web-Banner.jpg"} />
				 <img className='d-lg-none' src={publicUrl+"assets/img/website/NATA-Post-Moblie-Banner.jpg"} /> 
				</div> */}
			</Carousel>
			


		);

        }
}

export default Banner